import { PropsWithChildren } from "react";
import { TextProps } from "../data";
import { fontWeightEnum } from "../enumerations/fontWeightEnum";
import styles from "./style.module.scss";

const P2: React.FC<
  PropsWithChildren & TextProps & React.HTMLAttributes<HTMLParagraphElement>
> = ({
  children,
  weight = "normal",
  color = "rgba(0, 0, 0, 0.88)",
  ...props
}) => {
  return (
    <p
      {...props}
      className={`${styles.p2} ${props.className}`}
      style={{
        fontWeight: fontWeightEnum[weight],
        color: color,
        ...props.style,
      }}
    >
      {children}
    </p>
  );
};

export default P2;
